<template>
  <div class="charts-page">
    <div class="row topCardGrid">
      <sp-card :valor="total_licencas" :descricao="$t('empreenda.tooltipCardLicenciamentos')" :lgGrid="4" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"/>
      <sp-card :valor="total_licencas_ultimoMes" :descricao="$t('empreenda.tooltipCardLicenciamentosUltimoMes')" :lgGrid="4" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"/>
      <sp-card tema='info' stripe='none' :valor="this.tmaCard" sufix="dias" :descricao="$t('empreenda.tooltipCardTMA') + this.TMA.ano" :lgGrid="4" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"/>
    </div>

    <div class="row">
      <div class="flex md12 sm12">
        <sp-360-panel :title="`${this.tabela.titulo} - ${this.subAtual}`" :tooltipOptions="tabela.topTooltipOptions" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
            <div class="flex-box">
              <sp-map v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="mapaSP" :habilitarAnimacaoClique="true"></sp-map>

              <div id="divTabelaFiltro">
                <div id="divFiltroTempo">
                  <multiselect id="selectSegmentoTemporal"
                    name="selectTemporal"
                    :placeholder="$t('mainDashboard.filterTablePlaceholder')"
                    :value="corteTemporalEscolhido"
                    :options="corteTemporal"
                    :searchable="false"
                    :close-on-select="true"
                    :show-labels="false"
                    :allowEmpty="false"
                    v-model="corteTemporalEscolhido"
                    track-by="atributo"
                    label="label"
                    @input="updateSub" />
                </div>
                <sp360-data-table v-if="!tabela.tableDataSecao.data.length" id="tabelaLicPorSub" ref="licPorSub" :apiMode="false" :data="tabela.tableDataSubs.data"
                  :fields="tabela.tableFieldsSubs" :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage" :footerObj="footerGeral" />
                <sp360-data-table v-if="tabela.tableDataSecao.data.length" id="tabelaSecaoPorSub" ref="secaoPorSub" :apiMode="false" :data="tabela.tableDataSecao.data"
                :fields="tabela.tableFieldsSecao" :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage" :footerObj="footerSub" />
              </div>
            </div>
        </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex lg12 md12">
        <sp-360-panel class="chart-widget" :title="tituloHorizontalBar" :tooltipOptions="barTooltipOptions" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
          <sp360-chart  class="lic-chart" v-bind:data="licenciamentosBarData" :options="optionsLicenciamentoBar" type="vertical-bar" />
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>

import constantes from '@/utils/ConstantesGlobais'
import mapaDeCalor from '@/services/MapaDeCalor'
import MethGlob from '@/utils/MetodosGlobais'
import SpMap from '@/components/maps/360-maps/SPMap'
import _ from 'lodash'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import CorUtils from '@/utils/CorUtils'
import * as d3 from 'd3'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import SpCard from '@/components/ui/cards/SP360Card'
import Multiselect from 'vue-multiselect'

export default {
  name: 'licenciamentos',
  components: {
    Sp360Panel,
    SpMap,
    Sp360DataTable,
    Sp360Chart,
    SpCard,
    Multiselect,
  },
  data () {
    return {
      cores: {
        claro: '#f1f1fa',
        medio: '#9c9cd4',
        escuro: '#3b3b72',
      //   claro: CorUtil.getCorPorNomeSp360(CorUtil.VIOLETA_CLARO),
      //   medio: CorUtil.getCorPorNomeSp360(CorUtil.VIOLETA_MEDIO),
      //   escuro: CorUtil.getCorPorNomeSp360(CorUtil.VIOLETA_ESCURO),
      },
      dataRef: '',
      fonte: '',
      sigla: '',
      barTooltipOptions: {},
      secoesFiltradas: [],
      footerGeral: {},
      footerSub: {},
      TMA: {},
      tmaCard: {},
      subAtual: this.$t('mainDashboard.general'),
      ultimoClickIdSub: -1,
      ultimoClickNomeSub: '',
      corteTemporal: [
        {
          atributo: 'ULTIMO_MES',
          label: 'Último mês fechado',
        },
        {
          atributo: 'ULTIMO_SEMESTRE',
          label: 'Últimos 6 meses fechados',
        },
        {
          atributo: 'ULTIMO_ANO',
          label: 'Último ano',
        },
        {
          atributo: 'DESDE_SEMPRE',
          label: 'Desde Maio/2017',
        },
      ],
      corteTemporalEscolhido: {
        atributo: 'DESDE_SEMPRE',
        label: 'Desde Maio/2017',
      },
      dados: {},
      licenciamentosBarData: {},
      options: {},
      total_licencas: 0,
      total_licencas_ultimoMes: 0,
      secaoPorSub: [],
      tabela: {
        titulo: this.$t('empreenda.tituloLicenciamentosSub'),
        tableDataSubs: {
          'data': [],
        },
        tableDataSecao: {
          'data': [],
        },
        tableFieldsSubs: [
          {
            name: 'nome_subprefeitura',
            title: this.$t('empreenda.tableFields.subprefeitura'),
            width: '33%',
          },
          {
            name: 'total_licencas',
            sortField: 'total_licencas',
            title: this.$t('empreenda.tableFields.licenciamentos'),
            callback: MethGlob.thousandSeparator,
            width: '33%',
          },
          {
            name: 'porcentagem',
            sortField: 'porcentagem',
            title: this.$t('empreenda.tableFields.porcLicenciamentos'),
            callback: MethGlob.formataPercentual,
            width: '33%',
          },
        ],
        tableFieldsSecao: [
          {
            name: 'ds_secao',
            title: this.$t('empreenda.tableFields.secao'),
            width: '33% ',
          },
          {
            name: 'total_licencas',
            sortField: 'total_licencas',
            title: this.$t('empreenda.tableFields.licenciamentos'),
            callback: MethGlob.thousandSeparator,
            width: '33%',
          },
          {
            name: 'percentual_licencas',
            sortField: 'percentual_licencas',
            title: this.$t('empreenda.tableFields.porcLicenciamentosSecao'),
            callback: MethGlob.formataPercentual,
            width: '33%',
          },
        ],

        sortFunctions: {
          'total_licencas': MethGlob.ordenaTabelaParseInt,
          'percentual_licencas': MethGlob.ordenaTabelaParseFloat,
          'porcentagem': MethGlob.ordenaTabelaParseFloat,
        },

        topTooltipOptions: {
          content: this.$t('empreenda.tooltipLicenciamentosSub'),
          placement: 'bottom',
        },

        itemsPerPage: 12,
      },
      tituloHorizontalBar: this.$t('empreenda.tituloBarChartSecao'),
      optionsLicenciamentoBar: {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 20,
            bottom: 0,
          },
        },
        tooltips: {
          enabled: true,
          callbacks: MethGlob.percentualLabelCallback(false, true, 'pie'),
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false,
              maxRotation: 45,
              callback: MethGlob.formataStringCallback(20),
            },
            display: true,
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('empreenda.eixoXBarChartSecao'),
            },
            ticks: {
              callback: (value) => MethGlob.thousandSeparator(value),
            },
          }],
        },
      },
    }
  },
  mounted () {
    this.$store.dispatch('empreenda/TMAPorAno', {})
      .then((retorno) => {
        this.TMA = retorno.data.data.slice(-1)[0]
        this.tmaCard = MethGlob.formatarNumero(this.TMA.tempo_medio_dias, 2)
        // {fonte: fonte, data: dataRef}
        this.fonte = retorno.data.sigla_orgao + '-' + retorno.data.fonte
        this.dataRef = new Date(retorno.data.data_referencia_dado).toLocaleDateString('pt-BR')
        this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })
        this.sigla = retorno.data.sigla_orgao
      })

    Promise.all(this.corteTemporal.map((o) => {
      return this.$store.dispatch('empreenda/licenciamentosPorSubFechado', { intervalo: o.atributo })
    }))
      .then(
        (retorno) => {
          for (let i = 0; i < retorno.length; i++) {
            let o = this.corteTemporal[i]
            this.secaoPorSub[o.atributo] = retorno[i].data.data
          }
          this.total_licencas_ultimoMes = this.total_licencas_ultimoMes ? this.total_licencas_ultimoMes : this.secaoPorSub['ULTIMO_MES'].reduce((acc, curr) => acc + curr.total_licencas, 0)
          this.updateSub()
          this.populateLicenciamentoChart()
        }
      )
      .catch(
        (error) => {
          console.error(error)
        })
  },
  methods: {
    updateSub () {
      this.preencherTabelaSubs(this.secaoPorSub[this.corteTemporalEscolhido.atributo])
      if (this.ultimoClickIdSub > 0) {
        this.updateTableSecao(this.ultimoClickIdSub)
      }
    },
    filtrarPorRegiao (id) {
      let idNum = MethGlob.idSvgToNumeric(id)
      if (this.ultimoClickIdSub != idNum) {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub)
        this.$refs.mapa.diminuirOpacidadeTodas()
        this.$refs.mapa.aumentarOpacidade(id)
        this.updateTableSecao(idNum)
        this.ultimoClickNomeSub = id
        this.ultimoClickIdSub = idNum
      } else {
        this.$refs.mapa.limparClick(id)
        this.$refs.mapa.aumentarOpacidadeTodas()
        // this.updateTable(0)
        this.hideSecaoTable()
        this.ultimoClickNomeSub = null
        this.ultimoClickIdSub = 0
        // this.munAtual = this.$t('mainDashboard.general')
      }
    },
    updateTableSecao (idSub) {
      this.tabela.tableDataSecao.data = this.secaoPorSub[this.corteTemporalEscolhido.atributo][idSub].lista_licencas
      let x = this.secaoPorSub[this.corteTemporalEscolhido.atributo][idSub]
      let footer = {
        total_licencas: MethGlob.thousandSeparator(x.total_licencas),
        ds_secao: x.nome_subprefeitura,
      }
      this.footerSub = footer
      this.subAtual = this.secaoPorSub[this.corteTemporalEscolhido.atributo][idSub].nome_subprefeitura
    },
    hideSecaoTable () {
      this.tabela.tableDataSecao.data = []
      this.subAtual = this.$t('mainDashboard.general')
    },
    criarLegenda () {
      this.$refs.mapa.definirLegenda([this.cores.claro, this.cores.escuro],
        [this.$t('mainDashboard.legendaTitulo')])
    },
    preencherTabelaSubs (data) {
      data = _.cloneDeep(data)
      this.footerGeral = data.shift()
      this.footerGeral.total_licencas = MethGlob.thousandSeparator(this.footerGeral.total_licencas)

      this.tabela.tableDataSubs.data = []
      data = _.orderBy(data, ['total_licencas'], ['desc'])
      this.total_licencas = this.total_licencas ? this.total_licencas : data.reduce((acc, curr) => acc + curr.total_licencas, 0)
      data.forEach(obj => {
        let n = {}
        n.id_subprefeitura = obj.id_subprefeitura
        n.nome_subprefeitura = obj.nome_subprefeitura
        n.total_licencas = obj.total_licencas
        n.porcentagem = obj.percentual_licencas
        this.tabela.tableDataSubs.data.push(n)
      })

      this.pintarRegiao(this.tabela.tableDataSubs.data)
      this.$refs.mapa.setLegenda(data[data.length - 1].total_licencas, data[0].total_licencas, this.$t('empreenda.textoEixoLegenda.licenciamentosRegiao'), 6)
      this.criarLegenda()
    },
    populateLicenciamentoChart (d) {
      this.licenciamentosBarData = {}
      this.licenciamentosBarData.labels = []
      this.licenciamentosBarData.datasets = []
      let x = {}

      let l = this.secaoPorSub['DESDE_SEMPRE'][0].lista_licencas
      let cores = _.reverse(CorUtils.getVetorCoresPorTom('medio'))

      l.forEach(y => {
        if (y.total_licencas >= 1000) {
          x[y.ds_secao] = 0
        } else {
          x['Outros'] = 0
          this.secoesFiltradas.push(y.ds_secao)
        }
      })

      this.barTooltipOptions = {
        content: this.$t('empreenda.tooltipBarSecao') + this.secoesFiltradas.join('; '),
        placement: 'bottom',
      }

      // slice(0) faz uma copia da array e reverse() inverte a array, pois queremos começar do ultimo elemento apenas por questoes visuais do grafico
      this.corteTemporal.slice(0).reverse().map(o => {
        let y = _.clone(x)

        let d = this.secaoPorSub[o.atributo][0].lista_licencas

        d.forEach(obj => {
          if (Object.keys(y).includes(obj.ds_secao)) {
            y[obj.ds_secao] = obj.total_licencas
          } else {
            y['Outros'] += obj.total_licencas
          }
        })

        let cor = cores.shift()

        let dataset = {
          backgroundColor: cor,
          data: Object.values(y),
          label: o.label,
        }

        this.licenciamentosBarData.labels = Object.keys(y)
        this.licenciamentosBarData.datasets.push(dataset)
      })
    },
    pintarRegiao (dados) {
      let c = CorUtils.getCoresMapa()
      // dados.shift()
      dados = _.orderBy(dados, ['total_licencas'], ['asc'])
      let colorScale = d3.scaleLinear()
        .domain([_.first(dados).total_licencas, _.last(dados).total_licencas])
        .range([c.claro, c.escuro])

      dados.forEach((element) => {
        let id = 'sub' + element.id_subprefeitura
        this.$refs.mapa.pintarRegiao(id, colorScale(element.total_licencas))
      })
    },
  },
}
</script>

<style lang="scss">
.widget.chart-widget {
  .widget-body {
    height: 550px;
  }
}

.lic-chart{
  height: 700px;
}
.flex-box {
    display: flex;
    max-height: 50rem;
}

#mapaSP {
    width: 25%;
}

#divTabelaFiltro {
    width: 75%;
    height: auto
}
</style>
